import { useIntl } from "gatsby-plugin-intl"

import paths from "utils/paths"

const usePortfolioNavigationContent = (projectData, slug) => {
  const { formatMessage } = useIntl()
  const {
    overview,
    briefing,
    timelinePosts,
    progressStages,
    vision,
    gallery,
    location,
  } = projectData

  const {
    portfolioProjectSnapshot,
    portfolioProjectBriefing,
    portfolioProjectTimeline,
    portfolioProjectProgress,
    portfolioProjectVision,
    portfolioProjectGallery,
    portfolioProjectLocation,
  } = paths

  const getPortfolioNavigationContent = []

  if (overview && Object.keys(overview).length > 0) {
    getPortfolioNavigationContent.push({
      icon: "snapshot",
      label: `${formatMessage({
        id: "pages.portfolio.navigation.tabs.snapshot",
      })}`,
      path: `${portfolioProjectSnapshot(slug)}`,
    })
  }

  if (vision && Object.keys(vision).length > 0) {
    getPortfolioNavigationContent.push({
      icon: "vision",
      label: `${formatMessage({
        id: "pages.portfolio.navigation.tabs.vision",
      })}`,
      path: `${portfolioProjectVision(slug)}`,
    })
  }

  if (briefing && Object.keys(briefing).length > 0) {
    getPortfolioNavigationContent.push({
      icon: "briefing",
      label: `${formatMessage({
        id: "pages.portfolio.navigation.tabs.briefing",
      })}`,
      path: `${portfolioProjectBriefing(slug)}`,
    })
  }

  if (location && Object.keys(location).length > 0) {
    getPortfolioNavigationContent.push({
      icon: "location",
      label: `${formatMessage({
        id: "pages.portfolio.navigation.tabs.location",
      })}`,
      path: `${portfolioProjectLocation(slug)}`,
    })
  }

  if (progressStages && Object.keys(progressStages).length > 0) {
    getPortfolioNavigationContent.push({
      icon: "progress",
      label: `${formatMessage({
        id: "pages.portfolio.navigation.tabs.progress",
      })}`,
      path: `${portfolioProjectProgress(slug)}`,
    })
  }

  if (timelinePosts && Object.keys(timelinePosts).length > 0) {
    getPortfolioNavigationContent.push({
      icon: "timeline",
      label: `${formatMessage({
        id: "pages.portfolio.navigation.tabs.timeline",
      })}`,
      path: `${portfolioProjectTimeline(slug)}`,
    })
  }

  if (gallery && gallery.length > 0) {
    getPortfolioNavigationContent.push({
      icon: "gallery",
      label: `${formatMessage({
        id: "pages.portfolio.navigation.tabs.gallery",
      })}`,
      path: `${portfolioProjectGallery(slug)}`,
    })
  }

  if (getPortfolioNavigationContent.length <= 1) {
    return []
  }

  return getPortfolioNavigationContent
}

export default usePortfolioNavigationContent
